import React, { useEffect, useState } from "react";
import {
  getAllMatchesOddsCricketAPI,
} from "../service/cricket";
import store from "../redux/store";
import { Link, useNavigate } from "react-router-dom";
import { PERMISSION_MAP } from "../utils/constants";

export default function Dashboard() {
  const navigate = useNavigate();
  const userData = store.getState().account.userData;
  const userPermissions =
    PERMISSION_MAP[userData?.userType?.toUpperCase()] || [];

  const [matches, setMatches] = useState([]);

  useEffect(() => {
    getAllMatchesOddsCricketAPI().then(({ response }) =>
      setMatches(response || [])
    );
  }, []);

  /* ------------------ LINK TREE ------------------ */

  const linkTree = {
    admin: [
      { name: "Admin", link: "/admin", class: "bg-purple", isPermission: true, enum: "ADMIN" },
      { name: "Sub Admin", link: "/sub_admin", class: "bg-warning", isPermission: true, enum: "SUB_ADMIN" },
      { name: "Master", link: "/master", class: "bg-primary", isPermission: true, enum: "MASTER" },
      { name: "Super Agent", link: "/super_agent", class: "bg-success", isPermission: true, enum: "SUPER_AGENT" },
      { name: "Agent", link: "/agent", class: "bg-warning", isPermission: true, enum: "AGENT" },
      { name: "Client", link: "/client", class: "bg-danger", isPermission: true, enum: "CLIENT" },
    ],
    cash: [
      { name: "Debit / Credit (Client)", link: "/ct/client", class: "bg-primary", isPermission: true, enum: "CLIENT" },
      { name: "Debit / Credit (Agent)", link: "/ct/agent", class: "bg-success", isPermission: true, enum: "AGENT" },
      { name: "Debit / Credit (SA)", link: "/ct/super_agent", class: "bg-warning", isPermission: true, enum: "SUPER_AGENT" },
      { name: "Debit / Credit (Master)", link: "/ct/master", class: "bg-danger", isPermission: true, enum: "MASTER" },
      { name: "Debit / Credit (Sub Admin)", link: "/ct/sub_admin", class: "bg-warning", isPermission: true, enum: "SUB_ADMIN" },
      { name: "Debit / Credit (Admin)", link: "/ct/admin", class: "bg-purple", isPermission: true, enum: "ADMIN" },
    ],
    ledger: [
      { name: "Client Ledger", link: "/ledger/client", class: "bg-primary", isPermission: true, enum: "CLIENT" },
      { name: "Agent Ledger", link: "/ledger/agent", class: "bg-danger", isPermission: true, enum: "AGENT" },
      { name: "Super Agent Ledger", link: "/ledger/super_agent", class: "bg-success", isPermission: true, enum: "SUPER_AGENT" },
      { name: "Master Ledger", link: "/ledger/master", class: "bg-purple", isPermission: true, enum: "MASTER" },
      { name: "Sub Admin Ledger", link: "/ledger/sub_admin", class: "bg-warning", isPermission: true, enum: "SUB_ADMIN" },
      { name: "Admin Ledger", link: "/ledger/admin", class: "bg-purple", isPermission: true, enum: "ADMIN" },
    ],
    // ledger: [
    //   // { name: "My Ledger", link: "/ledger", class: "bg-primary", isPermission: true, enum: "CLIENT" },
    //   { name: "Client Ledger", link: "/ledger/client", class: "bg-success", isPermission: true, enum: "AGENT" },
    //   { name: "Agent Ledger", link: "/ledger/agent", class: "bg-warning", isPermission: true, enum: "SUPER_AGENT" },
    //   { name: "Super Agent Ledger", link: "/ledger/super", class: "bg-danger", isPermission: true, enum: "MASTER" },
    //   { name: "Master Ledger", link: "/ledger/master", class: "bg-warning", isPermission: true, enum: "SUB_ADMIN" },
    //   { name: "Sub Admin Ledger", link: "/ledger/subadmin", class: "bg-purple", isPermission: true, enum: "ADMIN" },
    // ],
  };

  /* ------------------ RENDER ------------------ */

  const renderLinkTreeBoxes = (treeKey) =>
    linkTree[treeKey]
      ?.filter(item => userPermissions.includes(item.enum))
      .map((item, index) => (
        <div key={item.link} className="col-lg-6 col-12">
          <a
            className={`small-box ${item.class}`}
            href={item.link}
            style={{ cursor: "pointer" }}
          >
            <div className="inner">
              <h3>{treeKey === "ledger" ? index + 2 : index + 1}</h3>
              <p>{item.name}</p>
            </div>
            <a
              className="small-box-footer"
              href={item.link}
            >
              More Info <i className="fas fa-arrow-circle-right" />
            </a>
          </a>
        </div>
      ));

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">

          {/* TOP DASHBOARD */}
          <div className="row">
            {[
              { id: "admin", title: `${userData?.userType} Details`, color: "bg-purple" },
              { id: "games", title: "Games", color: "bg-success" },
              { id: "cash", title: "Cash Transaction", color: "bg-warning" },
              { id: "ledger", title: "Ledger", color: "bg-danger" },
            ].map((box, i) => (
              <div
                key={box.id}
                className="col-lg-3 col-6"
                data-toggle="modal"
                data-target={`#modal-${box.id}`}
              >
                <div className={`small-box ${box.color}`}>
                  <div className="inner">
                    <h3>{i + 1}</h3>
                    <p>{box.title}</p>
                  </div>
                  <a className="small-box-footer" href={`#modal-${box.id}`}>
                    More Info <i className="fas fa-arrow-circle-right" />
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* MODALS */}
          {["admin", "cash", "ledger"].map((key) => (
            <div key={key} className="modal fade" id={`modal-${key}`}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="row last-box">
                      {/* Existing Boxes */}
                      {key === "ledger" && (
                        <div className="col-lg-6 col-12">
                          <a
                            className={`small-box bg-primary`}
                            href='/ledger'
                            style={{ cursor: "pointer" }} >
                            <div className="inner">
                              <h3>1</h3>
                              <p>My Ledger</p>
                            </div>
                            <a
                              className="small-box-footer"
                              href="/ledger">
                              More Info <i className="fas fa-arrow-circle-right" />
                            </a>
                          </a>
                        </div>
                      )}
                      {renderLinkTreeBoxes(key)}
                      {/* Extra Default Box Only for Ledger */}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* GAMES MODAL */}
          <div className="modal fade" id="modal-games">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-6 col-12">
                      <a className="small-box bg-primary" href="/game/inPlay">
                        <div className="inner">
                          <h3>1</h3>
                          <p>InPlay</p>
                        </div>
                        <div className="small-box-footer">
                          More Info <i className="fas fa-arrow-circle-right" />
                        </div>
                      </a>

                    </div>
                    <div className="col-lg-6 col-12">
                      <a className="small-box bg-success" href="/game/completeGame">
                        <div className="inner">
                          <h3>2</h3>
                          <p>Complete</p>
                        </div>
                        <div className="small-box-footer">
                          More Info <i className="fas fa-arrow-circle-right" />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
